import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { EsgLogo as EsgLogo$2 } from './style.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["className", "esgType", "onClick", "alt", "lazy", "size"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var getEsgLogoSettings = function getEsgLogoSettings() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var size = arguments.length > 1 ? arguments[1] : undefined;
  var alt = arguments.length > 2 ? arguments[2] : undefined;
  var checkedType = type ? type.toLowerCase() : '';
  switch (checkedType) {
    case 'landscape':
      {
        return {
          name: 'landscape',
          url: '/web/esg/esg-landscape-logo',
          desktopSize: size.desktop || 108,
          mobileSize: size.mobile || 80,
          altText: alt || 'ESG Certified'
        };
      }
    case 'square':
      {
        return {
          name: 'square',
          url: '/web/esg/esg-square-logo',
          desktopSize: size.desktop || 32,
          mobileSize: size.mobile || 32,
          altText: alt || 'ESG'
        };
      }
    case 'excursion':
      {
        return {
          name: 'excursion',
          url: '/web/esg/esg-excursion-logo',
          desktopSize: size.desktop || 153,
          mobileSize: size.mobile || 113,
          altText: alt || 'ESG Travel with care excursion'
        };
      }
    case 'portrait':
    default:
      {
        return {
          name: 'portrait',
          url: '/web/esg/esg-portrait-logo',
          desktopSize: size.desktop || 30,
          mobileSize: size.mobile || 30,
          altText: alt || 'ESG Certified'
        };
      }
  }
};
var EsgLogo = function EsgLogo(_ref) {
  var className = _ref.className,
    esgType = _ref.esgType,
    onClick = _ref.onClick,
    alt = _ref.alt,
    lazy = _ref.lazy,
    size = _ref.size,
    rest = _objectWithoutProperties(_ref, _excluded);
  var esgLogoSettings = getEsgLogoSettings(esgType, size, alt);
  if (!esgType || !esgLogoSettings) {
    return false;
  }
  return /*#__PURE__*/jsx(EsgLogo$2, _objectSpread(_objectSpread({
    className: className,
    onClick: onClick,
    desktopSize: esgLogoSettings.desktopSize,
    mobileSize: esgLogoSettings.mobileSize
  }, rest), {}, {
    children: /*#__PURE__*/jsx("img", {
      loading: lazy ? 'lazy' : 'eager',
      src: "//img.nltg.com/image/upload".concat(esgLogoSettings.url, ".svg"),
      alt: esgLogoSettings.altText
    })
  }));
};
EsgLogo.defaultProps = {
  className: null,
  alt: null,
  esgType: 'portrait',
  onClick: null,
  lazy: false,
  size: {}
};
var EsgLogo$1 = EsgLogo;

export { EsgLogo$1 as default };
//# sourceMappingURL=EsgLogo.js.map
